import { render, staticRenderFns } from "./ModulePager.vue?vue&type=template&id=13764839&scoped=true&"
import script from "./ModulePager.vue?vue&type=script&lang=js&"
export * from "./ModulePager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13764839",
  null
  
)

export default component.exports